const scale = 0.15;

export const appendStockingIcon = (svg, name) => {
  let icon = svg.append("defs").append("g").attr("id", name);
  icon
    .append("path")
    .attr(
      "d",
      "M89.483,25.218c-0.651-1.423-1.819-2.506-3.29-3.051L54.37,10.369c-3.028-1.122-6.407,0.417-7.535,3.432l-2.152,5.752 c-0.546,1.458-0.49,3.042,0.157,4.459c0.65,1.423,1.819,2.506,3.29,3.052l31.822,11.797c0.672,0.249,1.36,0.367,2.038,0.367 c2.378,0,4.62-1.453,5.497-3.799l2.152-5.752C90.186,28.218,90.13,26.635,89.483,25.218z"
    )
    .attr("transform", `translate(0,0) scale(${scale})`);

  icon
    .append("path")
    .attr(
      "d",
      "M40.356,46.734c-1.32,3.53-5.283,5.332-8.815,4.021l-1.206-0.467c-7.51-2.786-15.61,0.946-18.436,8.495l-0.982,2.626 c-1.362,3.64-1.222,7.592,0.396,11.126c1.624,3.551,4.54,6.257,8.173,7.603l4.771,2.007l17.902,6.636 c2.226,0.825,4.507,1.216,6.753,1.216c7.877,0,15.305-4.811,18.212-12.581l13.224-35.346c-0.487-0.092-33.504-12.299-33.626-12.35 L40.356,46.734z"
    )
    .attr("transform", `translate(0,0) scale(${scale})`);
};

export const appendTreeIcon = (svg, name) => {
  let icon = svg.append("defs").append("g").attr("id", name);
  icon
    .append("polygon")
    .attr(
      "points",
      "65.166,54.513 82.522,54.513 62.446,35.242 76.296,35.242 50,10 23.704,35.242 37.554,35.242 17.478,54.513 34.834,54.513 10,78.352 42.113,78.352 42.113,90 57.886,90 57.886,78.352 90,78.352"
    )
    .attr("transform", `translate(0,0) scale(${scale})`);
};
